const PENDING_PAYMENT_KEY = "starlive_pending_payment"

export function storePendingPayment(order) {
  if (!order || !Number(order.id)) return
  localStorage.setItem(PENDING_PAYMENT_KEY, JSON.stringify({
    orderId: Number(order.id),
    tradeNo: String(order.trade_no || "").slice(0, 64),
    channel: String(order.channel || "").slice(0, 20),
    createdAt: Date.now(),
    resumePending: true
  }))
}

export function pendingPayment() {
  try {
    const value = JSON.parse(localStorage.getItem(PENDING_PAYMENT_KEY) || "null")
    if (!value || !Number(value.orderId) || Date.now() - Number(value.createdAt || 0) > 24 * 60 * 60 * 1000) {
      clearPendingPayment()
      return null
    }
    return { ...value, resumePending: value.resumePending !== false }
  } catch (_error) {
    return null
  }
}

export function claimPendingPaymentResume() {
  const value = pendingPayment()
  if (!value || value.resumePending === false) return null
  try {
    localStorage.setItem(PENDING_PAYMENT_KEY, JSON.stringify({ ...value, resumePending: false }))
    return value
  } catch (_error) {
    clearPendingPayment()
    return null
  }
}

export function clearPendingPayment() {
  localStorage.removeItem(PENDING_PAYMENT_KEY)
}

function providerUrl(action) {
  const url = String((action || {}).url || "")
  if (!/^https:\/\//i.test(url)) throw new Error("PAYMENT.INVALID_PROVIDER_URL")
  try {
    const parsed = new URL(url)
    if (parsed.protocol !== "https:" || !parsed.hostname) throw new Error("PAYMENT.INVALID_PROVIDER_URL")
    return parsed.href
  } catch (_error) {
    throw new Error("PAYMENT.INVALID_PROVIDER_URL")
  }
}

export function prepareExternalPaymentWindow() {
  const paymentWindow = window.open("about:blank", "_blank")
  if (!paymentWindow) return null
  try { paymentWindow.opener = null } catch (_error) {}
  return paymentWindow
}

export function closeExternalPaymentWindow(paymentWindow) {
  if (!paymentWindow || paymentWindow.closed) return
  try { paymentWindow.close() } catch (_error) {}
}

export function redirectToPayment(action, order, paymentWindow) {
  const url = providerUrl(action)
  storePendingPayment(order)
  if (!paymentWindow || paymentWindow.closed) return { opened: false, url }
  try {
    paymentWindow.location.replace(url)
    return { opened: true, url }
  } catch (_error) {
    closeExternalPaymentWindow(paymentWindow)
    return { opened: false, url }
  }
}
